<!--  -->
<template>
    <div class="business-content-main isumarry-content">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn" style="min-height: 0">
            <div class="search-ctn-left">
                <div class="search-name">客户/供应商</div>
                <el-select
                    class="search-item"
                    size="small"
                    style="width: 200px"
                    v-model="searchData.Keyword"
                    remote
                    filterable
                    allow-create
                    clearable
                    placeholder="请输入客户/供应商名称"
                    :remote-method="searchCustom"
                    v-select-scroll-more="searchCustomLoad"
                    @visible-change="customerVisibleChange($event)"
                    popper-class="my-select"
                >
                    <el-option v-for="item in cusOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName">
                        <div class="name">
                            {{ item.EntpCusName }}
                            <span v-if="item.CallNum" class="phone">{{ ` ( 电话：${item.CallNum} )` }}</span>
                        </div>
                    </el-option>
                </el-select>
                <el-button class="search-btn btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                <el-button class="search-btn" size="small" @click="resetSearch">重置</el-button>
            </div>
            <div class="search-ctn-right">
                <div class="section-summary">
                    <div>
                        <span>合计：{{ summaryStr }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-ctn">
            <el-container style="height: 700px; width: 80%; margin-right: 10px">
                <el-table
                    highlight-current-row
                    style="width: 100%"
                    :header-cell-style="{ background: '#F2F6FC' }"
                    border=""
                    :data="tableData"
                    height="700"
                    ref="multipleTable"
                    :row-class-name="tableRowClassName"
                    @row-click="rowClick"
                    :row-key="getRowKeys"
                    @sort-change="sortChange"
                    v-el-table-infinite-scroll="tableLoad"
                    empty-text="暂无未结数据"
                    :summary-method="getSummaries"
                    show-summary
                >
                    <el-table-column show-overflow-tooltip min-width="160" prop="EntpCusName" label="客户/供应商"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100" prop="RSumPayable" label="总应收"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100" prop="PSumPayable" label="总应付"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100" prop="Balance" label="总余额"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="80" prop="PreBalance" label="上期余额"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="80" prop="CurRSumPayable" label="本期应收"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="80" prop="CurRAlreadyPaid" label="本期已收"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="80" prop="CurPSumPayable" label="本期应付"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="80" prop="CurPAlreadyPaid" label="本期已付"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="80" prop="CurBalance" label="本期余额"></el-table-column>
                </el-table>
            </el-container>
            <el-container style="height: 700px; width: 20%">
                <el-table
                    v-loading="loading"
                    style="width: 100%"
                    :header-cell-style="{ background: '#F2F6FC' }"
                    border=""
                    :data="orderApplyData"
                    height="700"
                    ref="multipleTable2"
                    :row-class-name="tableRowClassName"
                    empty-text="暂无未结数据"
                    :summary-method="getSummaries2"
                    show-summary
                >
                    <el-table-column show-overflow-tooltip min-width="100px" prop="ApplyTime" label="月份"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="120" prop="UnBalance" label="未结金额"></el-table-column>
                </el-table>
            </el-container>
        </div>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import elTableInfiniteScroll from '@/assets/js/directives/table-infinite-scroll';
import breadcrumb from '@/components/common/breadcrumb';
import Vue from 'vue';
export default {
    mixins: [],
    name: '',
    components: {
        breadcrumb,
        elTableColumn
    },
    data() {
        return {
            summaryStr: '',
            datetime1: '',
            loading: '',
            stopFresh: false,
            isShowSummary: false,
            searchData: {
                Keyword: '',
                SortProp: '',
                SortType: '',
                page: 1,
                limit: 25
            },
            searchParams: {},
            currentRow: {},
            tableData: [],
            orderApplyData: [],
            tableDataLength: 0,
            permission: {},
            stateList: [
                { Text: '全部', Value: '-1' },
                { Text: '未提交', Value: '0' },
                { Text: '已提交', Value: '1' },
                { Text: '已结部分', Value: '3' },
                { Text: '已结算', Value: '4' },
                { Text: '已撤销', Value: '2' }
            ],
            SIdList: [],
            cusId: [],
            // 用于客户名称列表，分页搜索
            cusOptions: [],
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    //当前页面使用了keepAlive,不会触发beforeDestroy钩子
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        next();
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);
        if (this.tableCode) this.getSetsData();
    },
    mounted() {
        this.getTableData();
    },
    directives: {
        'el-table-infinite-scroll': elTableInfiniteScroll
    },
    methods: {
        handleKeyEvent(e) {
            let key = window.event.keyCode;
            let that = this;
            if (key === 13) {
                that.handleSearch();
            }
            //下键
            if (key == 40) {
                if (that.dataindex != that.tableDataLength - 1) {
                    if (that.currentRow && that.currentRow.SettleId) {
                        that.dataindex++;
                    } else that.dataindex = 0;
                    let index = that.dataindex;
                    that.$nextTick(() => {
                        if (that.$refs.multipleTable) {
                            that.currentRow = that.$refs.multipleTable.data[index];
                            that.$refs.multipleTable.setCurrentRow(that.$refs.multipleTable.data[index]);
                            that.getRecieptDetail();
                        }
                    });
                }
            }
            //上键
            if (key == 38) {
                if (that.dataindex != 0) {
                    that.dataindex--;
                    let index = that.dataindex;
                    that.$nextTick(() => {
                        if (that.$refs.multipleTable) {
                            that.currentRow = that.$refs.multipleTable.data[index];
                            that.$refs.multipleTable.setCurrentRow(that.$refs.multipleTable.data[index]);
                            that.getRecieptDetail();
                        }
                    });
                }
            }
        },
        tableLoad() {
            if (!this.stopFresh) {
                if (this.tableData && this.tableData.length > 0) this.searchData.page += 1;
                else this.searchData.page = 1;
                this.getTableData();
            }
        },
        tableRowClassName({ row, rowIndex }) {
            //把每一行的索引放进row
            row.index = rowIndex;
        },
        rowClick(row, column, event) {
            this.dataindex = row.index;
            this.currentRow = row;
            this.multipleSelection = [];
            this.getRecieptDetail();
        },
        getRecieptDetail() {
            let item = this.currentRow;
            if (item) {
                this.orderCode = item.OrderCode;
                this.loading = true;
                let url = '/api/RevenueManagement_N/GetCusPRDetailByCId';
                this.$util
                    .axiosGet({
                        url: url,
                        data: {
                            EntpCusId: item.EntpCusId
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        if (res.data) {
                            this.orderApplyData = res.data;
                        }
                    })
                    .catch(() => {})
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        // 客户名称列表，搜索
        async searchCustom(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.cusOptions = [];
            }
            if (this.cusForm.stopLoad) return;
            const data = await this.$util.searchCustomerAndSupplier(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit);
            if (data) {
                if (!data) return;
                this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                this.cusOptions = [...this.cusOptions, ...data];
            }
        },
        // 客户名称列表，加载更多
        searchCustomLoad() {
            this.cusForm.Page += 1;
            this.searchCustom();
        },
        customerVisibleChange() {
            //可以把这些常用的数据放到缓存里面
            this.searchCustom();
        },
        // 勾选统计
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        resetSearch() {
            this.searchData = {
                State: '',
                Keyword: '',
                OrderCode: '',
                StartDate: '',
                EndDate: '',
                ApplyId: '',
                SortProp: '',
                SortType: '',
                page: 1,
                limit: 25
            };
            this.datetime1 = '';
            this.searchCustom('');
        },
        getTableData() {
            let that = this;
            if (that.searchData.page == 1) {
                that.searchParams = { ...that.searchData };
            } else {
                that.searchParams.page = that.searchData.page;
            }
            that.stopFresh = true;

            that.$util
                .axiosGet({
                    url: '/api/RevenueManagement_N/GetItemizedSummary',
                    data: that.searchParams
                })
                .then(res => {
                    let data = res.data;
                    that.tableDataLength = res.count;
                    if (!data) {
                        if (that.searchData.page == 1) that.tableData = [];
                        return;
                    }

                    that.summaryStr = data.SummaryStr;

                    let list = [...that.tableData, ...data.DataList];
                    that.tableData = list;

                    that.stopFresh = data.DataList.length < that.searchData.limit;
                });
        },
        handleSearch() {
            this.tableData = [];
            this.searchData.page = 1;
            this.getTableData();
        },
        confirm(item) {
            let that = this;
            if (item.SettleId && !item.IsSettle) {
                that.currentRow = item;
                that.multipleSelection = [];
                that.multipleSelection.push(item);
                that.cusName = that.multipleSelection[0].EntpCusName;
                that.isShowConfirmDialog = true;
            } else {
                that.$util.warningMsg('申请数据异常，请刷新后重新操作');
            }
        },
        batchComfirms() {
            let that = this;
            if (that.multipleSelection.length > 0) {
                that.cusName = that.multipleSelection[0].EntpCusName;
                that.isShowConfirmDialog = true;
            } else {
                that.$util.warningMsg('请先勾选需要申请的项');
            }
        },
        //选中时间
        onDate1TimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;
            this.searchData.page = 1;
            this.tableData = [];
            this.getTableData();
        },
        // 记录每行的key值
        getRowKeys(row) {
            return row.EntpCusId;
        },
        getSummaries(param) {
            const { data } = param;
            let d1 = 0;
            let d2 = 0;
            let d3 = 0;
            let d4 = 0;
            let d5 = 0;
            let d6 = 0;
            let d7 = 0;
            let d8 = 0;
            let d9 = 0;
            data.forEach(ele => {
                d1 = (Number(d1) + Number(ele.RSumPayable)).toFixed(2);
                d2 = (Number(d2) + Number(ele.PSumPayable)).toFixed(2);
                d3 = (Number(d3) + Number(ele.Balance)).toFixed(2);
                d4 = (Number(d4) + Number(ele.PreBalance)).toFixed(2);
                d5 = (Number(d5) + Number(ele.CurPSumPayable)).toFixed(2);
                d6 = (Number(d6) + Number(ele.CurRAlreadyPaid)).toFixed(2);
                d7 = (Number(d7) + Number(ele.CurPSumPayable)).toFixed(2);
                d8 = (Number(d8) + Number(ele.CurPAlreadyPaid)).toFixed(2);
                d9 = (Number(d9) + Number(ele.CurBalance)).toFixed(2);
            });
            return ['合计：' + this.tableData.length, d1, d2, d3, d4, d5, d6, d7, d8, d9];
        },
        getSummaries2(param) {
            const { data } = param;
            let amountTotal = 0;
            data.forEach(ele => {
                amountTotal = (Number(amountTotal) + Number(ele.UnBalance)).toFixed(2);
            });
            return ['合计：' + this.orderApplyData.length, amountTotal];
        }
    }
};
</script>
<style lang="less" scoped>
.data-count {
    padding: 5px;
    display: flex;
    .data-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 12.5%;
        border-right: 1px solid @border4Color;
        > p:nth-child(1) {
            margin-bottom: 5px;
        }
    }
}
#search-dc-dialog,
#confirm-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }
    .search-item-dialog {
        width: 340px;
        height: auto;
        .dialog-footer {
            text-align: right;
        }
        .el-form-item {
            margin-bottom: 0;
        }
    }
    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
#confirm-dialog::-webkit-scrollbar {
    display: none;
}
.v-content {
    width: 100%;
    height: calc(100vh);
}
.section-title {
    display: flex;
    justify-content: space-between;
    height: 30px;
    line-height: 30px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;
}
.table-ctn {
    display: flex;
    width: 100%;
    margin-bottom: 10px;
}
</style>
<style lang="less">
.isumarry-content {
    .el-table {
        margin-bottom: 0px;

        th {
            padding: 4px 0;
        }

        .el-table__body {
            .el-table__row {
                .cell {
                    button {
                        padding: 0;
                    }
                }

                td {
                    padding: 2px 0;
                }
            }
        }
        .el-table__footer {
            td {
                padding: 4px 0;
            }
        }
    }
}
.el-table__row {
    td:not(is-hidden):last-child {
        border-left: 1px solid #ebeef5;
    }
}
.el-table__header {
    th:not(is-hidden):last-child {
        border-left: 1px solid #ebeef5;
    }
}
.el-table {
    overflow: visible !important;
}
</style>
